import { Button } from 'antd';
import React from 'react';
import { Link } from 'umi';

import { useNavigateWithFromState } from '@/hooks/route-hook';
import { SettingFilled } from '@ant-design/icons';
import { useLocation } from 'umi';

const App: React.FC = () => {
  const navigate = useNavigateWithFromState();
  const toSetting = () => {
    navigate('/user-setting');
  };

  const { pathname } = useLocation();

  return (
    <Link to="/user-setting">
      <Button
        type="default"
        style={
          pathname.startsWith('/user-setting')
            ? { backgroundColor: 'rgba(22, 119, 255, 1)', color: 'white' }
            : { backgroundColor: 'rgba(249, 249, 249, 1)' }
        }
        shape="circle"
        onClick={toSetting}
        icon={<SettingFilled />}
      />
    </Link>
  );
};

export default App;
